export default __webpack_public_path__ + "static/media/logo.dfce4ea7.png";